import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SocialRedesService {
  socialred: any[] = [
    {
      url: 'https://twitter.com/home?lang=ES',
      class: 'twitter',
      icon: 'bx bxl-twitter',
    },
    {
      url: 'https://www.facebook.com/junior.prudencio.33',
      class: 'facebook',
      icon: 'bx bxl-facebook',
    },
    {
      url: 'https://www.instagram.com/junior_alex_pm/',
      class: 'instagram',
      icon: 'bx bxl-instagram',
    },
    {
      url: 'https://www.linkedin.com/in/junior-pm/',
      class: 'linkedin',
      icon: 'bx bxl-linkedin',
    },
  ];





  constructor() {}
}
